import { Card, CardContent } from "@mui/material";
import "./CSS/rea.css";
import { Trans, useTranslation } from "react-i18next";

const REA = () => {
    const { t } = useTranslation()
    return (
        <>
            <Card className="card" sx={{ minWidth: 275 }}>
                <CardContent>
                    <h1 className="rea-title"><Trans>{t("rea.title")}</Trans></h1>
                    <iframe className="rea-frame" title="Registre des entreprises autorisées (REA)" src="https://registre-rea.amp.gouv.qc.ca/1A/RegistreLcop.Web/Recherche" ></iframe>
                </CardContent>
            </Card>
        </>
    );
  }
  
  export default REA;